var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "app-container" },
    [
      _c("BjRouteTabs", {
        attrs: { "route-list": _vm.ORDER_ABNORMAL_FIVE_ROUTE_LIST },
      }),
      _c("BjPage", {
        ref: "BjPage",
        attrs: {
          "query-params": _vm.queryParams,
          "col-span": _vm.colSpan,
          "default-sort": _vm.defaultSort,
          "get-action": _vm.queryApi,
          serial: _vm.serial,
          "before-reset-search": _vm.beforeResetSearch,
          "tooltip-config": { contentMethod: false, enterable: true },
          selection: _vm.selection,
        },
        on: {
          "sort-change": _vm.sortChange,
          handleSelectionChange: _vm.handleSelectionChange,
          showSetting: _vm.SortableTable.show,
          "header-dragend": _vm.SortableTable.handleHeaderDragend,
          "header-contextmenu": _vm.SortableTable.handleHeaderContextmenu,
        },
        scopedSlots: _vm._u([
          {
            key: "baseForm",
            fn: function () {
              return [
                _c("BjSelectChannelStore", {
                  attrs: {
                    span: _vm.colSpan,
                    "query-params": _vm.queryParams,
                    "query-props": ["channel", "storeIdList"],
                    multiple: "",
                  },
                }),
                _c(
                  "el-col",
                  { attrs: { span: _vm.colSpan } },
                  [
                    _c(
                      "el-form-item",
                      {
                        attrs: {
                          label: _vm.$t("InternalOrder.No"),
                          prop: "orderNo",
                        },
                      },
                      [
                        _c("BjInput", {
                          attrs: {
                            placeholder: _vm.$t("InternalOrder.No"),
                            comma: "",
                          },
                          nativeOn: {
                            keyup: function ($event) {
                              if (
                                !$event.type.indexOf("key") &&
                                _vm._k(
                                  $event.keyCode,
                                  "enter",
                                  13,
                                  $event.key,
                                  "Enter"
                                )
                              ) {
                                return null
                              }
                              return _vm.handleQuery.apply(null, arguments)
                            },
                          },
                          model: {
                            value: _vm.queryParams.orderNo,
                            callback: function ($$v) {
                              _vm.$set(_vm.queryParams, "orderNo", $$v)
                            },
                            expression: "queryParams.orderNo",
                          },
                        }),
                      ],
                      1
                    ),
                  ],
                  1
                ),
                _c(
                  "el-col",
                  { attrs: { span: _vm.colSpan } },
                  [
                    _c(
                      "el-form-item",
                      { attrs: { label: _vm.$t("InternalOrder.order") } },
                      [
                        _c("BjDateRangePicker", {
                          attrs: { placeholder: _vm.$t("InternalOrder.order") },
                          model: {
                            value: _vm.queryParamsTime_order,
                            callback: function ($$v) {
                              _vm.queryParamsTime_order = $$v
                            },
                            expression: "queryParamsTime_order",
                          },
                        }),
                      ],
                      1
                    ),
                  ],
                  1
                ),
                !_vm.$store.getters.cusId
                  ? _c(
                      "el-col",
                      { attrs: { span: _vm.colSpan } },
                      [
                        _c(
                          "el-form-item",
                          {
                            attrs: {
                              label: _vm.$t("billingPage.CustomerName"),
                              prop: "cusId",
                            },
                          },
                          [
                            _c("BjSelectLov", {
                              attrs: {
                                "option-list": _vm.customerList,
                                placeholder: _vm.$t("customerNameText"),
                              },
                              model: {
                                value: _vm.queryParams.cusId,
                                callback: function ($$v) {
                                  _vm.$set(_vm.queryParams, "cusId", $$v)
                                },
                                expression: "queryParams.cusId",
                              },
                            }),
                          ],
                          1
                        ),
                      ],
                      1
                    )
                  : _vm._e(),
              ]
            },
            proxy: true,
          },
          {
            key: "tableOperation",
            fn: function () {
              return undefined
            },
            proxy: true,
          },
          {
            key: "tableColumn",
            fn: function () {
              return [
                _vm._l(_vm.dropCols, function (col, index) {
                  return [
                    col.prop !== "bjTableAction"
                      ? _c("el-table-column", {
                          key:
                            "col_" +
                            index +
                            "_" +
                            col.prop +
                            "_" +
                            (col.width || "auto"),
                          attrs: {
                            prop: col.prop,
                            label: col.label,
                            width: col.width || "auto",
                            fixed: col.fixed || false,
                            align: "center",
                            "class-name": "item",
                            "show-overflow-tooltip":
                              col.prop !== "bjTableAction",
                          },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "default",
                                fn: function (scope) {
                                  return [
                                    false
                                      ? void 0
                                      : col.prop == "cusId"
                                      ? [
                                          _vm._v(
                                            _vm._s(
                                              _vm.customerList.bjGet(
                                                scope.row.cusId
                                              )
                                            )
                                          ),
                                        ]
                                      : col.prop === "outerOrderNo"
                                      ? [
                                          _c("span", [
                                            _vm._v(
                                              _vm._s(scope.row.webReference)
                                            ),
                                          ]),
                                          _c("BjCopyIcon", {
                                            attrs: {
                                              copy: scope.row.webReference,
                                            },
                                          }),
                                        ]
                                      : col.prop === "totalOrderStatus"
                                      ? [
                                          _c(
                                            "el-tag",
                                            {
                                              attrs: {
                                                type:
                                                  scope.row[col.prop] === 8
                                                    ? "success"
                                                    : "info",
                                              },
                                            },
                                            [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.$t(
                                                    _vm.ORDER_INTERNAL_ALL_STATUS_LIST.bjGet(
                                                      scope.row[col.prop]
                                                    )
                                                  )
                                                )
                                              ),
                                            ]
                                          ),
                                        ]
                                      : col.prop === "orderHandleStatus"
                                      ? [
                                          _vm._v(
                                            " " +
                                              _vm._s(
                                                [0, 6].includes(
                                                  scope.row[col.prop]
                                                )
                                                  ? _vm.$t(
                                                      _vm.ORDER_WMS_STATUS_LIST.bjGet(
                                                        scope.row[col.prop]
                                                      )
                                                    )
                                                  : ""
                                              ) +
                                              " "
                                          ),
                                        ]
                                      : col.prop === "orderStatusStr"
                                      ? [
                                          _c(
                                            "el-tag",
                                            {
                                              attrs: {
                                                type:
                                                  scope.row[col.prop] ===
                                                  "Proccessing"
                                                    ? "success"
                                                    : "info",
                                              },
                                            },
                                            [
                                              _vm._v(
                                                _vm._s(scope.row[col.prop])
                                              ),
                                            ]
                                          ),
                                        ]
                                      : col.prop === "pickUpTime"
                                      ? [
                                          _c("span", [
                                            _vm._v(
                                              _vm._s(
                                                scope.row[col.prop] ? "Yes" : ""
                                              )
                                            ),
                                          ]),
                                        ]
                                      : col.prop === "shippingMethod"
                                      ? [
                                          _c("el-tag", [
                                            _vm._v(
                                              _vm._s(
                                                _vm.$t(
                                                  _vm.CSG_ORDER_SHIPPING_METHODS_LIST.bjGet(
                                                    scope.row[col.prop]
                                                  )
                                                )
                                              )
                                            ),
                                          ]),
                                        ]
                                      : col.prop === "creationDate"
                                      ? [
                                          _c("span", [
                                            _vm._v(
                                              _vm._s(
                                                _vm._f("timeOperateTwoHour")(
                                                  scope.row[col.prop]
                                                )
                                              )
                                            ),
                                          ]),
                                        ]
                                      : col.prop === "failureReason"
                                      ? [
                                          _vm._v(
                                            " " +
                                              _vm._s(
                                                _vm.$t(
                                                  _vm.LANG_ZH_EN_PS_LIST.bjGet(
                                                    scope.row[col.prop]
                                                  )
                                                )
                                              ) +
                                              " "
                                          ),
                                        ]
                                      : col.prop === "orderTime"
                                      ? [
                                          _c("span", [
                                            _vm._v(
                                              _vm._s(
                                                _vm._f("timeOptimization")(
                                                  scope.row[col.prop]
                                                )
                                              )
                                            ),
                                          ]),
                                        ]
                                      : col.prop === "lastUpdateDate"
                                      ? [
                                          _c("span", [
                                            _vm._v(
                                              _vm._s(
                                                _vm._f("timeOperateTwoHour")(
                                                  scope.row[col.prop]
                                                )
                                              )
                                            ),
                                          ]),
                                        ]
                                      : col.prop === "isNeedQuota"
                                      ? [
                                          _c("span", [
                                            _vm._v(
                                              _vm._s(
                                                scope.row.shippingMethod &&
                                                  scope.row.shippingMethod
                                                    .toLowerCase()
                                                    .includes("csg manual")
                                                  ? scope.row.isNeedQuota
                                                    ? "Yes"
                                                    : " "
                                                  : " "
                                              )
                                            ),
                                          ]),
                                        ]
                                      : col.prop === "quotedAmount"
                                      ? [
                                          _c("span", [
                                            _vm._v(
                                              _vm._s(
                                                scope.row.shippingMethod &&
                                                  scope.row.shippingMethod
                                                    .toLowerCase()
                                                    .includes("csg manual")
                                                  ? scope.row.quotedAmount
                                                  : " "
                                              )
                                            ),
                                          ]),
                                        ]
                                      : col.prop === "quotaOrNot"
                                      ? [
                                          scope.row.shippingMethod &&
                                          scope.row.shippingMethod
                                            .toLowerCase()
                                            .includes("csg manual")
                                            ? _c("el-tag", [
                                                _vm._v(
                                                  _vm._s(
                                                    _vm.$t(
                                                      _vm.ORDER_QUOTE_TYPES_STATUS.bjGet(
                                                        scope.row[col.prop]
                                                      )
                                                    )
                                                  )
                                                ),
                                              ])
                                            : _c("span", [_vm._v(_vm._s(" "))]),
                                        ]
                                      : col.prop === "isProvideSize"
                                      ? [
                                          _c("span", [
                                            _vm._v(
                                              _vm._s(
                                                scope.row.shippingMethod &&
                                                  scope.row.shippingMethod
                                                    .toLowerCase()
                                                    .includes("customer manual")
                                                  ? scope.row.isProvideSize
                                                    ? "Yes"
                                                    : " "
                                                  : " "
                                              )
                                            ),
                                          ]),
                                        ]
                                      : col.prop === "isSizeWrite"
                                      ? [
                                          _c("span", [
                                            _vm._v(
                                              _vm._s(
                                                scope.row.shippingMethod &&
                                                  scope.row.shippingMethod
                                                    .toLowerCase()
                                                    .includes("customer manual")
                                                  ? scope.row.repLength
                                                    ? "Yes"
                                                    : " "
                                                  : " "
                                              )
                                            ),
                                          ]),
                                        ]
                                      : _c("span", [
                                          _vm._v(
                                            _vm._s(
                                              _vm._f("timeFilters")(
                                                scope.row[col.prop],
                                                scope.row[col.prop]
                                              )
                                            )
                                          ),
                                        ]),
                                  ]
                                },
                              },
                            ],
                            null,
                            true
                          ),
                        })
                      : _vm._e(),
                    col.prop === "bjTableAction"
                      ? _c("el-table-column", {
                          key:
                            "col_" +
                            index +
                            "_" +
                            col.prop +
                            "_" +
                            (col.width || "auto"),
                          attrs: {
                            prop: col.prop,
                            label: col.label,
                            width: col.width || "auto",
                            fixed: col.fixed || "right",
                            align: "center",
                          },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "default",
                                fn: function (props) {
                                  return [
                                    _c(
                                      "el-button",
                                      {
                                        staticClass: "edit-btn",
                                        attrs: { type: "text" },
                                        on: {
                                          click: function ($event) {
                                            return _vm.toViewOrder(props.row)
                                          },
                                        },
                                      },
                                      [_vm._v(_vm._s(_vm.$t("viewText")))]
                                    ),
                                    _c(
                                      "el-dropdown",
                                      {
                                        directives: [
                                          {
                                            name: "hasDropdownChildren",
                                            rawName: "v-hasDropdownChildren",
                                          },
                                        ],
                                        on: {
                                          command: function ($event) {
                                            return _vm.command(
                                              $event,
                                              props.row
                                            )
                                          },
                                        },
                                      },
                                      [
                                        _c(
                                          "span",
                                          { staticClass: "el-dropdown-link" },
                                          [
                                            _vm._v(
                                              _vm._s(
                                                _vm.$t(
                                                  "AccountManagement.common.operate"
                                                )
                                              )
                                            ),
                                            _c("i", {
                                              staticClass:
                                                "el-icon-arrow-down el-icon--right",
                                            }),
                                          ]
                                        ),
                                        _c(
                                          "el-dropdown-menu",
                                          {
                                            attrs: { slot: "dropdown" },
                                            slot: "dropdown",
                                          },
                                          [
                                            props.row.shippingMethod &&
                                            props.row.shippingMethod
                                              .toLowerCase()
                                              .includes("csg manual") &&
                                            !_vm.$store.getters.cusId
                                              ? _c(
                                                  "el-dropdown-item",
                                                  {
                                                    attrs: {
                                                      disabled:
                                                        props.row.isNeedQuota &&
                                                        props.row.quotaOrNot !=
                                                          2,
                                                      command: "fillInLabel",
                                                    },
                                                  },
                                                  [
                                                    _vm._v(
                                                      " " +
                                                        _vm._s(
                                                          _vm.$t(
                                                            "WarehouseManagement.form.Label"
                                                          )
                                                        ) +
                                                        " "
                                                    ),
                                                  ]
                                                )
                                              : _vm._e(),
                                            props.row.shippingMethod &&
                                            props.row.shippingMethod
                                              .toLowerCase()
                                              .includes("csg manual") &&
                                            !_vm.$store.getters.cusId
                                              ? _c(
                                                  "el-dropdown-item",
                                                  {
                                                    attrs: {
                                                      disabled:
                                                        !props.row
                                                          .isNeedQuota ||
                                                        props.row.quotaOrNot ==
                                                          2,
                                                      command: "fillInPrice",
                                                    },
                                                  },
                                                  [
                                                    _vm._v(
                                                      " " +
                                                        _vm._s(
                                                          _vm.$t(
                                                            "WarehouseManagement.form.Quote"
                                                          )
                                                        ) +
                                                        " "
                                                    ),
                                                  ]
                                                )
                                              : _vm._e(),
                                            props.row.shippingMethod &&
                                            props.row.shippingMethod
                                              .toLowerCase()
                                              .includes("csg manual") &&
                                            _vm.$store.getters.cusId
                                              ? _c(
                                                  "el-dropdown-item",
                                                  {
                                                    attrs: {
                                                      disabled:
                                                        !props.row
                                                          .isNeedQuota ||
                                                        props.row.quotaOrNot !=
                                                          1,
                                                      command: "ConfirmPrice",
                                                    },
                                                  },
                                                  [
                                                    _vm._v(
                                                      " " +
                                                        _vm._s(
                                                          _vm.$t(
                                                            "WarehouseManagement.form.isQuotation"
                                                          )
                                                        ) +
                                                        " "
                                                    ),
                                                  ]
                                                )
                                              : _vm._e(),
                                            props.row.shippingMethod ==
                                            "CUSTOMER MANUAL"
                                              ? _c(
                                                  "el-dropdown-item",
                                                  {
                                                    attrs: {
                                                      disabled:
                                                        props.row
                                                          .isProvideSize &&
                                                        ![
                                                          props.row.repLength,
                                                          props.row.repWidth,
                                                          props.row.repHeight,
                                                          props.row.repWeight,
                                                        ].every(function (e) {
                                                          return e > 0
                                                        }),
                                                      command: "fillInLabel",
                                                    },
                                                  },
                                                  [
                                                    _vm._v(
                                                      " " +
                                                        _vm._s(
                                                          _vm.$t(
                                                            "WarehouseManagement.form.Label"
                                                          )
                                                        ) +
                                                        " "
                                                    ),
                                                  ]
                                                )
                                              : _vm._e(),
                                            props.row.shippingMethod ==
                                              "CUSTOMER MANUAL" &&
                                            !_vm.$store.getters.cusId
                                              ? _c(
                                                  "el-dropdown-item",
                                                  {
                                                    attrs: {
                                                      disabled:
                                                        !props.row
                                                          .isProvideSize ||
                                                        ![
                                                          props.row.repLength,
                                                          props.row.repWidth,
                                                          props.row.repHeight,
                                                          props.row.repWeight,
                                                        ].every(function (e) {
                                                          return e == null
                                                        }),
                                                      command: "fillInSize",
                                                    },
                                                  },
                                                  [
                                                    _vm._v(
                                                      " " +
                                                        _vm._s(
                                                          _vm.$t(
                                                            "WarehouseManagement.form.Dimension"
                                                          )
                                                        ) +
                                                        " "
                                                    ),
                                                  ]
                                                )
                                              : _vm._e(),
                                            _c(
                                              "el-dropdown-item",
                                              {
                                                attrs: {
                                                  command: "ModifyTrans",
                                                },
                                              },
                                              [
                                                _vm._v(
                                                  " " +
                                                    _vm._s(
                                                      _vm.$t(
                                                        "WarehouseManagement.form.Shipping"
                                                      )
                                                    ) +
                                                    " "
                                                ),
                                              ]
                                            ),
                                            _c(
                                              "el-dropdown-item",
                                              {
                                                attrs: {
                                                  disabled: [0, 6].includes(
                                                    props.row.orderHandleStatus
                                                  ),
                                                  command: "cancel",
                                                },
                                              },
                                              [
                                                _vm._v(
                                                  " " +
                                                    _vm._s(
                                                      _vm.$t("cancelText")
                                                    ) +
                                                    " "
                                                ),
                                              ]
                                            ),
                                          ],
                                          1
                                        ),
                                      ],
                                      1
                                    ),
                                  ]
                                },
                              },
                            ],
                            null,
                            true
                          ),
                        })
                      : _vm._e(),
                  ]
                }),
              ]
            },
            proxy: true,
          },
        ]),
      }),
      _c("delveryDialog", {
        ref: "delveryDialogRef",
        on: { reFresh: _vm.reFresh },
      }),
      _c(
        "el-dialog",
        {
          attrs: {
            title:
              "" +
              _vm.$t("editText") +
              _vm.$t("goodsSku.detail.Price") +
              " (AUD)",
            visible: _vm.dialogFormVisible,
            width: "400px",
          },
          on: {
            "update:visible": function ($event) {
              _vm.dialogFormVisible = $event
            },
          },
        },
        [
          _c(
            "el-form",
            { ref: "form", attrs: { model: _vm.form, rules: _vm.rules } },
            [
              _c(
                "el-form-item",
                {
                  attrs: {
                    prop: "quotedAmount",
                    label: _vm.$t("goodsSku.detail.Price") + ":",
                  },
                },
                [
                  _c("BjInputMoney", {
                    staticStyle: {
                      width: "300px",
                      "text-decoration-color": "brown",
                    },
                    attrs: {
                      disabled: _vm.form.isDisabled,
                      placeholder: "AUD",
                    },
                    model: {
                      value: _vm.form.quotedAmount,
                      callback: function ($$v) {
                        _vm.$set(_vm.form, "quotedAmount", $$v)
                      },
                      expression: "form.quotedAmount",
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "div",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer",
            },
            [
              !_vm.form.isDisabled
                ? _c(
                    "el-button",
                    {
                      on: {
                        click: function ($event) {
                          _vm.dialogFormVisible = false
                        },
                      },
                    },
                    [_vm._v(_vm._s(_vm.$t("cancelText")))]
                  )
                : _vm._e(),
              !_vm.form.isDisabled
                ? _c(
                    "el-button",
                    {
                      attrs: { type: "primary" },
                      on: {
                        click: function ($event) {
                          return _vm.saveAmount()
                        },
                      },
                    },
                    [_vm._v(_vm._s(_vm.$t("saveText")))]
                  )
                : _vm._e(),
              _vm.form.isDisabled
                ? _c(
                    "el-button",
                    {
                      attrs: { type: "primary" },
                      on: {
                        click: function ($event) {
                          return _vm.cancelAmount()
                        },
                      },
                    },
                    [_vm._v(_vm._s(_vm.$t("WarehouseManagement.form.refuse")))]
                  )
                : _vm._e(),
              _vm.form.isDisabled
                ? _c(
                    "el-button",
                    {
                      attrs: { type: "primary" },
                      on: {
                        click: function ($event) {
                          return _vm.doneAmount()
                        },
                      },
                    },
                    [_vm._v(_vm._s(_vm.$t("WarehouseManagement.form.agree")))]
                  )
                : _vm._e(),
            ],
            1
          ),
        ],
        1
      ),
      _vm.dialogShippingVisible
        ? _c(
            "el-dialog",
            {
              attrs: {
                title: _vm.$t("WarehouseManagement.form.Shipping"),
                visible: _vm.dialogShippingVisible,
                width: "400px",
              },
              on: {
                "update:visible": function ($event) {
                  _vm.dialogShippingVisible = $event
                },
              },
            },
            [
              _c(
                "el-form",
                {
                  ref: "Shippingform",
                  attrs: {
                    model: _vm.Shippingform,
                    rules: _vm.ShippingformRules,
                  },
                },
                [
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        prop: "shippingMethod",
                        label: _vm.$t("orderNewPatch.Shipping") + ":",
                      },
                    },
                    [
                      _c("BjSelectLov", {
                        attrs: { "option-list": _vm.ShippingList },
                        model: {
                          value: _vm.Shippingform.shippingMethod,
                          callback: function ($$v) {
                            _vm.$set(_vm.Shippingform, "shippingMethod", $$v)
                          },
                          expression: "Shippingform.shippingMethod",
                        },
                      }),
                    ],
                    1
                  ),
                  _vm.Shippingform.shippingMethod == "CSG MANUAL"
                    ? _c(
                        "el-form-item",
                        {
                          attrs: {
                            prop: "isNeedQuota",
                            label:
                              _vm.$t("WarehouseManagement.form.Quotation") +
                              ":",
                          },
                        },
                        [
                          _c("BjSelectLov", {
                            attrs: { "option-list": _vm.STATUS_YES_TRUE },
                            model: {
                              value: _vm.Shippingform.isNeedQuota,
                              callback: function ($$v) {
                                _vm.$set(_vm.Shippingform, "isNeedQuota", $$v)
                              },
                              expression: "Shippingform.isNeedQuota",
                            },
                          }),
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm.Shippingform.shippingMethod == "CUSTOMER MANUAL"
                    ? _c(
                        "el-form-item",
                        {
                          attrs: {
                            prop: "isProvideSize",
                            label:
                              _vm.$t("WarehouseManagement.form.check") + ":",
                          },
                        },
                        [
                          _c("BjSelectLov", {
                            attrs: { "option-list": _vm.STATUS_YES_TRUE },
                            model: {
                              value: _vm.Shippingform.isProvideSize,
                              callback: function ($$v) {
                                _vm.$set(_vm.Shippingform, "isProvideSize", $$v)
                              },
                              expression: "Shippingform.isProvideSize",
                            },
                          }),
                        ],
                        1
                      )
                    : _vm._e(),
                ],
                1
              ),
              _c(
                "div",
                {
                  staticClass: "dialog-footer",
                  attrs: { slot: "footer" },
                  slot: "footer",
                },
                [
                  _c(
                    "el-button",
                    {
                      on: {
                        click: function ($event) {
                          _vm.dialogShippingVisible = false
                        },
                      },
                    },
                    [_vm._v(_vm._s(_vm.$t("cancelText")))]
                  ),
                  _c(
                    "el-button",
                    {
                      attrs: { type: "primary" },
                      on: {
                        click: function ($event) {
                          return _vm.updateShapping()
                        },
                      },
                    },
                    [_vm._v(_vm._s(_vm.$t("okText")))]
                  ),
                ],
                1
              ),
            ],
            1
          )
        : _vm._e(),
      _c(
        "el-dialog",
        {
          attrs: {
            title: _vm.$t("WarehouseManagement.form.Dimension"),
            visible: _vm.dialogSizeVisible,
            width: "400px",
          },
          on: {
            "update:visible": function ($event) {
              _vm.dialogSizeVisible = $event
            },
          },
        },
        [
          _c(
            "el-form",
            {
              ref: "SizeForm",
              attrs: { model: _vm.SizeForm, rules: _vm.SizeFormRules },
            },
            [
              _c(
                "el-form-item",
                {
                  attrs: {
                    label: _vm.$t("WarehouseManagement.form.Length"),
                    prop: "repLength",
                  },
                },
                [
                  _c(
                    "BjInputMoney",
                    {
                      model: {
                        value: _vm.SizeForm.repLength,
                        callback: function ($$v) {
                          _vm.$set(_vm.SizeForm, "repLength", $$v)
                        },
                        expression: "SizeForm.repLength",
                      },
                    },
                    [_c("template", { slot: "append" }, [_vm._v("cm")])],
                    2
                  ),
                ],
                1
              ),
              _c(
                "el-form-item",
                {
                  attrs: {
                    label: _vm.$t("WarehouseManagement.form.Width"),
                    prop: "repWidth",
                  },
                },
                [
                  _c(
                    "BjInputMoney",
                    {
                      model: {
                        value: _vm.SizeForm.repWidth,
                        callback: function ($$v) {
                          _vm.$set(_vm.SizeForm, "repWidth", $$v)
                        },
                        expression: "SizeForm.repWidth",
                      },
                    },
                    [_c("template", { slot: "append" }, [_vm._v("cm")])],
                    2
                  ),
                ],
                1
              ),
              _c(
                "el-form-item",
                {
                  attrs: {
                    label: _vm.$t("WarehouseManagement.form.Height"),
                    prop: "repHeight",
                  },
                },
                [
                  _c(
                    "BjInputMoney",
                    {
                      model: {
                        value: _vm.SizeForm.repHeight,
                        callback: function ($$v) {
                          _vm.$set(_vm.SizeForm, "repHeight", $$v)
                        },
                        expression: "SizeForm.repHeight",
                      },
                    },
                    [_c("template", { slot: "append" }, [_vm._v("cm")])],
                    2
                  ),
                ],
                1
              ),
              _c(
                "el-form-item",
                {
                  attrs: {
                    label: _vm.$t("WarehouseManagement.form.Weight"),
                    prop: "repWeight",
                  },
                },
                [
                  _c(
                    "BjInputMoney",
                    {
                      model: {
                        value: _vm.SizeForm.repWeight,
                        callback: function ($$v) {
                          _vm.$set(_vm.SizeForm, "repWeight", $$v)
                        },
                        expression: "SizeForm.repWeight",
                      },
                    },
                    [_c("template", { slot: "append" }, [_vm._v("kg")])],
                    2
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "div",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer",
            },
            [
              _c(
                "el-button",
                {
                  on: {
                    click: function ($event) {
                      _vm.dialogSizeVisible = false
                    },
                  },
                },
                [_vm._v(_vm._s(_vm.$t("cancelText")))]
              ),
              _c(
                "el-button",
                {
                  attrs: { type: "primary" },
                  on: {
                    click: function ($event) {
                      return _vm.updateSize()
                    },
                  },
                },
                [_vm._v(_vm._s(_vm.$t("okText")))]
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }